
import { HttpService } from '../common/http/http.service';
import { Path } from "../../../app.config";
import { UserSearchCriteria } from '../../../model/user/userSearchCriteria.model';
import { UserImpersonation } from '../../../model/user/userImpersonation.model';
import { User } from '../../../model/user/user.model';

export class UserService {
    private httpsSrv: HttpService;

    public static $inject: Array<string> = ["HttpService"];
    constructor(httpsService: HttpService) {
        this.httpsSrv = httpsService;
    }

    getUserList(ceid: number, gridArg: UserSearchCriteria) {
        var options = { url: Path.APIUrl.GetAllUserListUrl(), method: "POST", data: { ceid: ceid, param: gridArg } };
        return this.httpsSrv.execute(options);
    }
    
    getTranslation(lang: string) {
        var options = { url:  Path.APIUrl.GetLocale() +lang+".json", method: "GET" };
        return this.httpsSrv.get(options);
    }

    getUserDetails(ceid: number, userId: number) {
        var options = { url: Path.APIUrl.GetUserDetails(), params: { ceid: ceid, userId: userId } };
        return this.httpsSrv.get(options);
    }

    EnableDisableUser(user: User, userMode: number) {
        var options = { url: Path.APIUrl.EnableDisableUser(), method: "POST", data: { user: user, userMode: userMode } };
        return this.httpsSrv.execute(options);
    }

    saveUser(user: User) {
        var opt = { url: Path.APIUrl.SaveUserUrl(), method: "POST", data: { user: user } };
        return this.httpsSrv.execute(opt);
    }

    checkLoginNameAvailability(loginName: string) {
        var options = { url: Path.APIUrl.CheckLoginNameAvailability(), params: { loginName: loginName } };
        return this.httpsSrv.get(options);
    }

    completeUserSetUp(user: User, identifier: string) {
        var opt = { url: Path.APIUrl.CompleteUserSetup(), method: "POST", data: { user: user, identifier: identifier } };
        return this.httpsSrv.execute(opt);
    }

    activateUserLoginGroup(user: User, uniqueIdentifier: string) {
        var opt = { url: Path.APIUrl.ActivateUserLoginGroupStatus(), method: "POST", data: { user: user, uniqueIdentifier } };
        return this.httpsSrv.execute(opt);
    }

    checkIfUserExistsInSameCompany(userId: number, ceid: number, email: string) {
        var options = { url: Path.APIUrl.CheckIfUserExistsInSameCompany(), params: { userId: userId, ceid: ceid, email: email } };
        return this.httpsSrv.get(options);
    }

    checkIfUserExists(BCId: number, CEID: number, email: string) {
        var options = { url: Path.APIUrl.CheckIfUserExists(), params: { BCId: BCId, CEID: CEID, email: email }, cache: true };
        return this.httpsSrv.get(options);
    }

    resendActivationMail(user: User) {
        var opt = { url: Path.APIUrl.ResendActivationMail(), method: "POST", data: { user: user } };
        return this.httpsSrv.execute(opt);
    }

    unlockUser(userNameorEmail: string) {
        var opt = { url: Path.APIUrl.UnlockUser(), method: "POST", data: { userNameorEmail: userNameorEmail } };
        return this.httpsSrv.execute(opt);
    }
    resetPassword(user: User, identifier: string) {
        var opt = { url: Path.APIUrl.ResetPassword(), method: "POST", data: { user: user, identifier: identifier } };
        return this.httpsSrv.execute(opt);
    }
    forgotPassword(userNameorEmail: string, notifyUser: boolean) {
        var opt = { url: Path.APIUrl.ForgotPassword(), method: "POST", data: { userNameorEmail: userNameorEmail, isEmailNotificationRequired: notifyUser } };
        return this.httpsSrv.execute(opt);
    }
    forgotUsername(emailId: string) {
        var opt = { url: Path.APIUrl.ForgotUsername(), method: "POST", data: { emailId: emailId } };
        return this.httpsSrv.execute(opt);
    }
    validateSecurityQuestions(user: User) {
        var opt = { url: Path.APIUrl.ValidateSecurityQuestions(), method: "POST", data: { user: user } };
        return this.httpsSrv.execute(opt);
    }
    updateUserPassword(user: User) {
        var opt = { url: Path.APIUrl.UpdateUserPassword(), method: "POST", data: { user: user } };
        return this.httpsSrv.execute(opt);
    }
    CheckIfGroupIsAtLimit(ceid: number,groupId: number, loginId : number ){
        var options = { url: Path.APIUrl.CheckIfGroupIsAtLimit(), params: { ceid: ceid, groupId: groupId, loginId: loginId } };
        return this.httpsSrv.get(options);
    }


    //Edit Profile APIs
    getCurrentUserProfileInfo() {
        var opt = { url: Path.APIUrl.UserProfileDetailsUrl() };
        return this.httpsSrv.get(opt);
    }

    verifyUserIdenity(user: User) {
        var opt = { url: Path.APIUrl.VerifyUserIdenityUrl(), method: "POST", data: { user: user } };
        return this.httpsSrv.execute(opt);
    }

    saveUserProfile(user: User) {
        var opt = { url: Path.APIUrl.UpdateUserProfileUrl(), method: "POST", data: { user: user } };
        return this.httpsSrv.execute(opt);
    }

    getAllSecurityQuestions() {
        var opt = { url: Path.APIUrl.GetAllSecurityQuestionsUrl() };
        return this.httpsSrv.get(opt);
    }

    saveUserPassword(user: User) {
        var opt = { url: Path.APIUrl.SaveUserPasswordUrl(), method: "POST", data: { user: user } };
        return this.httpsSrv.execute(opt);
    }

    saveSecretQuestionAnswer(user: User) {
        var opt = { url: Path.APIUrl.SaveUserSecretQuestionAnswerUrl(), method: "POST", data: { user: user } };
        return this.httpsSrv.execute(opt);
    }
    getDefaultPages() {
        var opt = { url: Path.APIUrl.getDefaultPagesUrl() };
        return this.httpsSrv.get(opt);
    }

    getSupportedCultures() {
        var opt = { url: Path.APIUrl.getSupportedCultures() };
        return this.httpsSrv.get(opt);
    }

    getSupportedCountry() {
        var opt = { url: Path.APIUrl.getSupportedCountry() };
        return this.httpsSrv.get(opt);
    }

    getPreferredLanguageFeature() {
        var opt = { url: Path.APIUrl.getPreferredLanguageFeature() };
        return this.httpsSrv.get(opt);
    }  

    getGoogleTranslationFeature() {
        var opt = { url: Path.APIUrl.getGoogleTranslationFeature() };
        return this.httpsSrv.get(opt);
    }

    getUserPIData(user: User) {
        var opt = { url: Path.APIUrl.logUserPIDataUrl(), method: "POST", data: { user: user } };
        return this.httpsSrv.execute(opt);
    }

    //UserImpersonation

    getUserImpersonationDetails(impersonatedUserId: number, ceid: number) {
        var opt = { url: Path.APIUrl.GetUserImpersonationDetailsUrl(), params: { impersonatedUserId: impersonatedUserId, ceid: ceid } }
        return this.httpsSrv.get(opt);
    }

    generateUserImpersonationLink(userImpersonation: UserImpersonation) {
        var opt = { url: Path.APIUrl.GenerateUserImpersonationLinkUrl(), method: "POST", data: { userImpersonation: userImpersonation } };
        return this.httpsSrv.execute(opt);
    }
}